// -*-mode: rjsx -*-
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
// eslint-disable-next-line
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableContainer from "@material-ui/core/TableContainer"
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// eslint-disable-next-line
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
//import FilterListIcon from '@material-ui/icons/FilterList';
import grey from "@material-ui/core/colors/grey"
import DashBarChart from "./DashBar2Chart.js"
import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import InfoIcon from '@material-ui/icons/InfoOutlined';
import DescriptionIcon from '@material-ui/icons/Description'


// eslint-disable-next-line
//import * as _ from "lodash"


// LOGGING SETUP
import appConfig from "./../../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<Dash3ColTable>")


function desc(a, b, orderBy) {

    log.trace("desc(): a =",a)
    log.trace("desc(): b =",b)
    log.trace("desc(): orderBy =",orderBy)

    const levelOrder = {
        "Federal": 1,
        "State": 2,
        "County": 3,
        "City": 4
    }
    
    switch (orderBy) {
    case "column1":
    case "column2":
        if (b[orderBy].val < a[orderBy].val) {
            return -1;
        }
        if (b[orderBy].val >= a[orderBy].val) {
            return 1;
        }
        break
    case "column3":
        if (levelOrder[b[orderBy].val] > levelOrder[a[orderBy].val]) {
            return -1;
        }
        if (levelOrder[b[orderBy].val] <= levelOrder[a[orderBy].val]) {
            return 1;
        }
        break
    case "chart1":
        if (b.col3 < a.col3) {
            return -1;
        }
        if (b.col3 > a.col3) {
            return 1;
        }
        break
    default:
    }

    /*
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    */
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

const getSorting = (order, orderBy) => {
    log.trace("getSorting(): order =", order)
    log.trace("getSorting(): orderBy =", orderBy)
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


function EnhancedTableHead(props) {
    const { classes,
            // eslint-disable-next-line            
            onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort,
            txtName, showPlace } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    const headCells = [
        { id: "column1", numeric: false, disablePadding: showPlace, label: txtName },
        { id: "column2", numeric: true, disablePadding: false, label: "Rank" },
        { id: "column3", numeric: true, disablePadding: false, label: "Level" },
        { id: 'chart1', numeric: false, chart: true, disablePadding: false, label: "Feedback Count" },
    ];

    return (
        <TableHead>
          <TableRow style={{
              backgroundColor: "#438CFF",
              // height: "36px", // this height is determined by the order arrow,
          }}>
            { showPlace &&
              <TableCell padding="checkbox">
                <div style={{
                    textAlign: "center",
                    color: "white",
                    fontSize: 19,
                }}>#</div>
              </TableCell>
            }

            {/* column 1 */}
            <TableCell
              classes={{
                  stickyHeader: classes.tableCellStickyHeader // this makes the actuall header color
              }}
              style={{paddingLeft: "16px"}}
              key={headCells[0].id}
              align="left"
              padding="none"
              sortDirection={orderBy === headCells[0].id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCells[0].id}
                direction={order}
                onClick={createSortHandler(headCells[0].id)}
                classes={{
                    root: classes.headLabelRoot,
                    icon: classes.headLabelIcon,
                }}>
                {headCells[0].label}
                {orderBy === headCells[0].id ? (
                    <span className={classes.visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                ) : null}
              </TableSortLabel>
            </TableCell>


            {/* column 2 */}
            <TableCell
              classes={{
                  stickyHeader: classes.tableCellStickyHeader // this makes the actuall header color
              }}
              style={{paddingLeft: "0px"}}
              key={headCells[1].id}
              align="right"
              padding="none"
              sortDirection={orderBy === headCells[1].id ? order : false}>
              <TableSortLabel
                active={orderBy === headCells[1].id}
                direction={order}
                onClick={createSortHandler(headCells[1].id)}
                classes={{
                    root: classes.headLabelRoot,
                    icon: classes.headLabelIcon,
                }}>
                {headCells[1].label}
                {orderBy === headCells[1].id ? (
                    <span className={classes.visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                ) : null}
              </TableSortLabel>
            </TableCell>

            {/* column 3 */}
            <TableCell
              classes={{
                  stickyHeader: classes.tableCellStickyHeader // this makes the actuall header color
              }}
              style={{paddingLeft: "0px"}}
              key={headCells[2].id}
              align="right"
              padding="none"
              sortDirection={orderBy === headCells[2].id ? order : false}>
              <TableSortLabel
                active={orderBy === headCells[2].id}
                direction={order}
                onClick={createSortHandler(headCells[2].id)}
                classes={{
                    root: classes.headLabelRoot,
                    icon: classes.headLabelIcon,
                }}>
                {headCells[2].label}
                {orderBy === headCells[2].id ? (
                    <span className={classes.visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                ) : null}
              </TableSortLabel>
            </TableCell>

            {/* chart1 head */}
            <TableCell
              classes={{
                  stickyHeader: classes.tableCellStickyHeader // this makes the actuall header color
              }}
              style={{paddingLeft: "16px"}}
              key={headCells[3].id}
              align="left"
              padding="none"
              sortDirection={orderBy === headCells[3].id ? order : false}>
              <div style={{position: "relative"}}>
              <TableSortLabel
                active={orderBy === headCells[3].id}
                direction={order}
                onClick={createSortHandler(headCells[3].id)}
                classes={{
                    root: classes.headLabelRoot,
                    icon: classes.headLabelIcon,
                }}>
                {headCells[3].label}
                {orderBy === headCells[3].id ? (
                    <span className={classes.visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                ) : null}
              </TableSortLabel>
              </div>
              <div className={classes.sublabel}>(vertical mark = last week)</div>
            </TableCell>
          </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
    theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
    : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
    },
    header1: {
        // flex: '1 1 100%',
        // backgroundColor: "grey"
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "17px",
        fontWeight: "600",
    },

    header2: {
        // flex: '1 1 100%',
        // backgroundColor: "black"
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "15px",
        color: "#65676b"
    },

    headersWrapper: {
        flex: '1 1 100%'
    },

    infoIconRoot: {
        fontSize: "27px"
    },

    tooltipTooltip: {
        // backgroundColor: theme.palette.common.white,
        backgroundColor: "#f2f2f299",
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    }
    
}));


function EnhancedTableToolbar(props) {
    const classes = useToolbarStyles()
    // eslint-disable-next-line
    const { info, header1, header2, numSelected, isInfoOpen, onInfoOpen, onInfoClosed } = props;

    const [infoOpen, setInfoOpen] = React.useState(false)

    const handleInfoTooltipClose = () => {
        log.trace("handleInfoTooltipClose()")
        //onInfoClosed()
        setInfoOpen(false);
    }

    const handleInfoTooltipOpen = () => {
        log.trace("handleInfoTooltipOpen()")
        
        if(infoOpen) {
            //onInfoClosed()
            setInfoOpen(false)
        } else {
            // onInfoOpen()
            setInfoOpen(true)
        }
    }

    React.useEffect(() => {
        /*
        log.trace("useEffect-Info(): isInfoOpen =", isInfoOpen)
        log.trace("useEffect-Info(): infoOpen =", infoOpen)
        if(isInfoOpen != infoOpen) {
            setInfoOpen(false)
        }
        */
    }, [isInfoOpen, infoOpen])
    
    return (
        <Toolbar
          className={clsx(classes.root, {
              [classes.highlight]: numSelected > 0,
          })}
        >
          <div className={classes.headersWrapper}>
            <Typography className={classes.header1} variant="h6" id="tableHeader1">
              {header1}
            </Typography>
            <Typography className={classes.header2} variant="h6" id="tableHeader2">
              {header2}
            </Typography>
          </div>
        { info === "issues" &&
          <ClickAwayListener onClickAway={handleInfoTooltipClose}>
            <div>
              <HtmlTooltip id="infoTooltip"
                           PopperProps={{
                               disablePortal: false,
                               strategy: "fixed",
                               placement: "bottom-end",
                               modifiers: 
                               {
                                   flip: {
                                       enabled: false // yes, this works!, need to be using 1.x
                                   },
                                   arrow: {
                                   }
                               },

                           }}
                           arrow // yes, this works, but make it like we have for the chart tooltip
                           open={infoOpen}
                           interactive
                           title={
                               <React.Fragment>
                                 <div id="infoDiv">
                                   <div style={{
                                       display: "flex",
                                       justifyContent: "center",
                                       alignItems: "center",
                                       verticalAlign: "center",
                                       height: "56px",
                                       fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
                                       borderBottomColor: "#65676b4d",
                                       borderBottomStyle: "solid",
                                       borderBottomWidth: "1px"
                                   }}>
                                     <span id="infoHeader1Text" style={{
                                         marginTop: "-4px",
                                         marginBottom: "-5px",
                                     }}><Typography style={{
                                         fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                         fontSize: "20px",
                                         fontWeight: 700,
                                         lineHeight: "24px",
                                     }}>About Issues Table</Typography></span>
                                   </div>

                                   <div id="infoSectionWrapper" style={{
                                       display: "flex",
                                       alignItems: "flex-start",
                                       paddingBottom: "16px",
                                       paddingTop: "14px",
                                       fontSize: "12px"
                                   }}>
                                     <DescriptionIcon style={{
                                         marginRight: "6px",
                                         fontSize: "12px",
                                         verticalAlign: "-3px",
                                         height: "24px",
                                         width: "24px"
                                     }}/>
                                     <div style={{
                                         display: "flex",
                                         flexDirection: "column",
                                         fontSize: "12px",
                                     }}>
                                       <div style={{
                                           fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "15px",
                                           fontWeight: 600,
                                           marginBottom: "4px",
                                           marginTop: "-1px"
                                       }}>Issue Column</div>

                                       <div style={{
                                           fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "13px",
                                           fontWeight: 400,
                                           // marginBottom: "-4px",
                                           // marginTop: "-1px",
                                           overflowWrap: "break-word",
                                           textAlign: "left",
                                           wordBreak: "break-word",
                                           color: "#65676b"
                                       }}>This column shows the issues ranked by number of user selections. <b><em>{"Hover over"}</em></b> the <b>issue</b> to see activity on the map.</div>
                                     </div>
                                   </div> {/* end section wrapper */}


                                   <div id="infoSectionWrapper" style={{
                                       display: "flex",
                                       alignItems: "flex-start",
                                       paddingBottom: "16px",
                                       paddingTop: "14px",
                                       fontSize: "12px"
                                   }}>
                                     <DescriptionIcon style={{
                                         marginRight: "6px",
                                         fontSize: "12px",
                                         verticalAlign: "-3px",
                                         height: "24px",
                                         width: "24px"
                                     }}/>
                                     <div style={{
                                         display: "flex",
                                         flexDirection: "column",
                                         fontSize: "12px",
                                     }}>
                                       <div style={{
                                           fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "15px",
                                           fontWeight: 600,
                                           marginBottom: "4px",
                                           marginTop: "-1px"
                                       }}>Feedback Counts Column</div>

                                       <div style={{
                                           fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "13px",
                                           fontWeight: 400,
                                           // marginBottom: "-4px",
                                           // marginTop: "-1px",
                                           overflowWrap: "break-word",
                                           textAlign: "left",
                                           wordBreak: "break-word",
                                           color: "#65676b"
                                       }}>
                                         This column has a  bar chart that shows{" "}
                                         <b>pro</b> (<em style={{color: "#7db47b"}}>{"green"}</em>) and
                                         {" "}<b>con</b> (<em style={{color: "#c5b62a"}}>{"yellow"}</em>)
                                         ratios of user opinion.
                                         {" "}<b><em>{"Hover over"}</em></b> a <b>bar</b> and areas will show colors that indicate their leaning. Color in areas with no feedback on the issue will not change.</div>
                                     </div>
                                   </div> {/* end section wrapper */}

                                   {/*
                                   <Typography style={{fontSize: "14px"}} color="inherit"></Typography>
                                   Brought <em>{"to you"}</em> by <span style={{color: "blue"}}>{'Lightning'}</span> <u>{'with love'}</u>.{' '}
                                   {" "}<br/><br/>
                                    */}
                                   
                                 </div>
                               </React.Fragment>
                           }>
                <IconButton aria-label="info" onClick={handleInfoTooltipOpen}>
                  <InfoIcon classes={{root: classes.infoIconRoot}}/>
                </IconButton>
              </HtmlTooltip>
            </div>
         </ClickAwayListener>
        }

        { info === "reasons" &&
          <ClickAwayListener onClickAway={handleInfoTooltipClose}>
            <div>
              <HtmlTooltip id="infoTooltip"
                           PopperProps={{
                               disablePortal: false,
                               strategy: "fixed",
                               placement: "bottom-end",
                               modifiers: 
                               {
                                   flip: {
                                       enabled: false // yes, this works!, need to be using 1.x
                                   },
                                   arrow: {
                                   }
                               },

                           }}
                           arrow // yes, this works, but make it like we have for the chart tooltip
                           open={infoOpen}
                           interactive
                           title={
                               <React.Fragment>
                                 <div id="infoDiv">
                                   <div style={{
                                       display: "flex",
                                       justifyContent: "center",
                                       alignItems: "center",
                                       verticalAlign: "center",
                                       height: "56px",
                                       fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
                                       borderBottomColor: "#65676b4d",
                                       borderBottomStyle: "solid",
                                       borderBottomWidth: "1px"
                                   }}>
                                     <span id="infoHeader1Text" style={{
                                         marginTop: "-4px",
                                         marginBottom: "-5px",
                                     }}><Typography style={{
                                         fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                         fontSize: "20px",
                                         fontWeight: 700,
                                         lineHeight: "24px",
                                     }}>About Reasons Table</Typography></span>
                                   </div>

                                   <div id="infoSectionWrapper" style={{
                                       display: "flex",
                                       alignItems: "flex-start",
                                       paddingBottom: "16px",
                                       paddingTop: "14px",
                                       fontSize: "12px"
                                   }}>
                                     <DescriptionIcon style={{
                                         marginRight: "6px",
                                         fontSize: "12px",
                                         verticalAlign: "-3px",
                                         height: "24px",
                                         width: "24px"
                                     }}/>
                                     <div style={{
                                         display: "flex",
                                         flexDirection: "column",
                                         fontSize: "12px",
                                     }}>
                                       <div style={{
                                           fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "15px",
                                           fontWeight: 600,
                                           marginBottom: "4px",
                                           marginTop: "-1px"
                                       }}>Reason Column</div>

                                       <div style={{
                                           fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "13px",
                                           fontWeight: 400,
                                           // marginBottom: "-4px",
                                           // marginTop: "-1px",
                                           overflowWrap: "break-word",
                                           textAlign: "left",
                                           wordBreak: "break-word",
                                           color: "#65676b"
                                       }}>This column shows names of reasons. <b><em>{"Hover over"}</em></b> the <b>reason</b> to see trending on the chart.</div>
                                     </div>
                                   </div> {/* end section wrapper */}


                                   <div id="infoSectionWrapper" style={{
                                       display: "flex",
                                       alignItems: "flex-start",
                                       paddingBottom: "16px",
                                       paddingTop: "14px",
                                       fontSize: "12px"
                                   }}>
                                     <DescriptionIcon style={{
                                         marginRight: "6px",
                                         fontSize: "12px",
                                         verticalAlign: "-3px",
                                         height: "24px",
                                         width: "24px"
                                     }}/>
                                     <div style={{
                                         display: "flex",
                                         flexDirection: "column",
                                         fontSize: "12px",
                                     }}>
                                       <div style={{
                                           fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "15px",
                                           fontWeight: 600,
                                           marginBottom: "4px",
                                           marginTop: "-1px"
                                       }}>Feedback Counts Column</div>

                                       <div style={{
                                           fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "13px",
                                           fontWeight: 400,
                                           // marginBottom: "-4px",
                                           // marginTop: "-1px",
                                           overflowWrap: "break-word",
                                           textAlign: "left",
                                           wordBreak: "break-word",
                                           color: "#65676b"
                                       }}>
                                         This column has a stacked bar chart that shows{" "}
                                         <b>pro</b> (<em style={{color: "#7db47b"}}>{"green"}</em>) and
                                         {" "}<b>con</b> (<em style={{color: "#c5b62a"}}>{"yellow"}</em>)
                                         ratios for the issue.
                                         </div>
                                     </div>
                                   </div> {/* end section wrapper */}


                                   <div id="infoSectionWrapper" style={{
                                       display: "flex",
                                       alignItems: "flex-start",
                                       paddingBottom: "16px",
                                       paddingTop: "14px",
                                       fontSize: "12px"
                                   }}>
                                     <DescriptionIcon style={{
                                         marginRight: "6px",
                                         fontSize: "12px",
                                         verticalAlign: "-3px",
                                         height: "24px",
                                         width: "24px"
                                     }}/>
                                     <div style={{
                                         display: "flex",
                                         flexDirection: "column",
                                         fontSize: "12px",
                                     }}>
                                       <div style={{
                                           fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "15px",
                                           fontWeight: 600,
                                           marginBottom: "4px",
                                           marginTop: "-1px"
                                       }}>Importance Chart</div>

                                       <div style={{
                                           fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
                                           fontSize: "13px",
                                           fontWeight: 400,
                                           // marginBottom: "-4px",
                                           // marginTop: "-1px",
                                           overflowWrap: "break-word",
                                           textAlign: "left",
                                           wordBreak: "break-word",
                                           color: "#65676b"
                                       }}>
                                         Chart shows <b>last week</b>'s data as{" "}
                                         <b><em style={{color: "#ff9800"}}>{"orange"}</em></b>.
                                         For latest data, if the ranking is down, then it's a <b><em style={{color: "#ff3333"}}>{"red dot"}</em></b>,{" "}if it's the same it's a <b><em style={{color: "black"}}>{"black dot"}</em></b> and if it's up, then it's a <b><em style={{color: "#00bf00"}}>{"green dot"}</em></b>.
                                         </div>
                                     </div>
                                   </div> {/* end section wrapper */}

                                   
                                   {/*
                                   <Typography style={{fontSize: "14px"}} color="inherit"></Typography>
                                   Brought <em>{"to you"}</em> by <span style={{color: "blue"}}>{'Lightning'}</span> <u>{'with love'}</u>.{' '}
                                   {" "}<br/><br/>
                                    */}
                                 </div>
                               </React.Fragment>
                           }>
                <IconButton aria-label="info" onClick={handleInfoTooltipOpen}>
                  <InfoIcon classes={{root: classes.infoIconRoot}}/>
                </IconButton>
              </HtmlTooltip>
            </div>
         </ClickAwayListener>
        }
          
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        marginTop: theme.spacing(2),
    },
    paper: {
        width: '100%',
        height: '100%',
        minHeight: 300,
        //        maxHeight: 500,
        paddingBottom: "64px", // compensate for the header
        // paddingBottom: "16px",
        marginBottom: theme.spacing(2),
        borderRadius: "8px",
    },
    table: {
        minWidth: 75,
        height: "100%",
//        maxWidth: 60,
//        maxHeight: 60,
        //        overflowY: "hidden"
    },
    tableWrapper: {
        // scroll
        // hidden
        // auto
        // visible
        // overflowX: 'auto', // hides within the left and top
        // overflowX: "scroll" // hidden with the scrollbar
        // overflowX: "scroll" // hidden with the scrollbar
        // overflowY: "scroll"
        // overflowX: "hidden" // hidden behind
        overflowX: "visible", // visible above the border
        // overflowY: "scroll" // visible above the border
    },
    tableContainer: {
        //        overflowX: "visible",
        //        overflowY: "scroll"
        /*
        overflowX: "hide",
        overflowY: "scroll"
        */

        // this is working +all the height down to the container have to be 100%, othervise
        // there is spilling over of the actual rows
        height: "100%",
        overflowX: "hidden",
        overflowY: "scroll",
    },

    tableCellStickyHeader: {
        top: 0,
        left: 0,
        zIndex: 2,
        position: "sticky",
        backgroundColor: "#438CFF",
        // position: "relative",
        paddingTop: "6px",
        paddingBottom: "12px",

        "&.MuiTableCell-paddingNone:last-child": {
            padding: 0,
            paddingTop: "6px",
            paddingRight: "0px",
            paddingBottom: "12px",
            paddingLeft: "0px"
        }
    },
    
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },

    sublabel: {
        color: "white",
        position: "absolute",
        top: "22px",
        left: "16px",
        fontSize: "11px",
    },

    headLabelRoot: {

        // fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontWeight: 600,
        
        color: "white",
        fontSize: "17px",

        // only this is working
        "&.MuiTableSortLabel-active": {
            color: theme.palette.common.white
        },

        '&:focus': {
            color: theme.palette.common.white
        },
        
        '&:hover': {
            color: grey[100],
            // fontSize: "15px", // stretches the whole thing
        },

        //        '& :active': {
        //            color: "white"
        //        }

    },

    headLabelIcon: {
        fontSize: 22,
        
        // this is possible, but does not work
        // '& svg': {
        //},
        
        '& path': {
            fill: theme.palette.common.white,
            // working, but don't need it
            //            '&:hover': {
            //                fill: red[100],
            //            },
        }
    },
    
    chartCell: {
        paddingTop: 0,
        paddingBottom: 0,
    },

    column1Value: {
        //        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontFamily: '"Segoe UI", "Segoe UI", Helvetica, Arial, sans-serif',
        fontWeight: 400,
        // fontSize: 17,
        fontSize: "17px",
        paddingRight: "0px",
        paddingLeft: "16px",
        //color: "#65676b"        
    },


    column2Value: {
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontWeight: 400,
        // fontSize: 17,
        fontSize: "15px",
        paddingRight: "0px",
        paddingLeft: "16px",
        //color: "#65676b"        
    },


    column3Value: {
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontWeight: 400,
        // fontSize: 17,
        fontSize: "15px",
        paddingRight: "0px",
        paddingLeft: "16px",
        // color: "#65676b"        
    },

    
    
    column1HeadCell: {
        paddingLeft: "10px"
    },

    externalTooltip: {
        position: "absolute", // will be absolute to the "wrapper" and parallel to the sheet
        display: "none", // do not display at first
        //        top: "-12px",
 	borderRadius: "5px",
        left: "0",
        padding: "0.6em 1em",
        background: "#fff",
        //   background: "red",
        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
        transition: "all 0.2s ease-out",
        pointerEvents: "none",
        zIndex: 100
    },


    infoTooltip: {
        position: "absolute", // will be absolute to the "wrapper" and parallel to the sheet
        display: "none", // do not display at first
        //        top: "-12px",
 	borderRadius: "5px",
        left: "0",
        padding: "0.6em 1em",
        background: "#fff",
        //   background: "red",
        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
        transition: "all 0.2s ease-out",
        pointerEvents: "none",
        zIndex: 100
    },

    
    tooltipItemName: {
        // fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "15px",
        //fontWeight: "600",
        marginRight: "10px",
        // color: "#00000099"
        //        color: "#000000",
        color: "#65676b"        
    },

    tooltipItemVal: {
        //fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontFamily: '"Segoe UI Semibold", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: "17px",
        //fontWeight: 600,
        // color: "#65676b"
        // color: "#00000099",
        color: "#000000",
        //color: "#65676b"        
    },
    

    externalTooltipAnchor: {
        position: "absolute",
        width: "12px",
        height: "12px",
        bottom: "-0",
        left: "50%",
        transform: "translate(-50%, 50%) rotate(45deg)",
        background: "white",
        border: "1px solid #ddd",
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        // backgroundColor: "red",
        // transformOrigin: "center center", // we don't need this
    },
    
    tableRowRoot: {
        //minHeight: "64px",
        cursor: "pointer",
        '&:hover': {
            cursor: "pointer"
        },
    },

}));

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        marginTop: "-5px",
        // height: "200px",
        //maxWidth: 220,
        width: "310px",
        // backgroundColor: '#f5f5f9',
        backgroundColor: "white",
        //color: 'rgba(0, 0, 0, 0.87)',
        color: "black",
        borderRadius: "8px",
        //        boxShadow: "0 12px 28px 0 var(--shadow-2),0 2px 4px 0 var(--shadow-1),inset 0 0 0 1px var(--shadow-inset)",
         //        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
        //boxShadow: "0 12px 28px rgba(52, 73, 94, .2), 0 12px 28px rgba(52, 73, 94, 0.1)",

        // first is the "big one" allaround
        // second is a little bit on the inside
        // inset is what's inside the box that defines the "border"
        // boxShadow: "0 12px 28px 0 red, 0 2px 4px 0 green, inset 0 0 0 1px yellow ",

        // below works, but with no shadown for arrow at the top
//        boxShadow: "0 12px 28px 0 rgba(52, 73, 94, .2), 0 2px 4px 0 rgba(52, 73, 94, .2), inset 0 0 0 1px rgba(52, 73, 94, .2) ",

        boxShadow: "0 12px 28px 0 rgba(52, 73, 94, .2), 0 2px 4px 0 rgba(52, 73, 94, .2), inset 0 0 0 1px rgba(52, 73, 94, .2) ",


        // actual insides
        fontFamily: '"Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
        fontSize: theme.typography.pxToRem(12),
        paddingBottom: "8px",
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "8px",
        
//        border: '1px solid #dadde9',
        // from the other
// 	borderRadius: "5px",
//        left: "0",
//        padding: "0.6em 1em",
//        background: "#fff",
        //   background: "red",
//        boxShadow: "0 6px 8px rgba(52, 73, 94, .2), 0 1px 1px rgba(52, 73, 94, 0.1)",
//        transition: "all 0.2s ease-out",
//        pointerEvents: "none",
//        zIndex: 100
        
    },
    tooltipPlacementLeft: {
        // margin: "250px 100px",
        //marginTop: "250px",
        //marginLeft: "400px",
    },
    arrow: {
        color: "white",
        width: "12px",
        height: "12px",
        // border: "1px solid #ddd",
        //        transform: "translate(-50%, 50%) rotate(45deg)!important",
        //transform: "rotate(45deg)!important",
        // border: "1px solid #dadde9",
//        boxShadow: "0 12px 28px 0 rgba(52, 73, 94, .2), 0 2px 4px 0 rgba(52, 73, 94, .2), inset 0 0 0 1px rgba(52, 73, 94, .2) ",
        // border-bottom-color:rgba(0, 0, 0, 0);
        //border-bottom-style:solid;
        //border-bottom-width:6px;
        
    },
//[x-placement*="bottom"]

    /*
    'popperArrow[x-placement*="bottom"]': {
        "& .MuiTooltip-arrow": {
            top: "0",
            left: "0",
            //            marginTop: "-0.71em",
            // marginTop: "0!important",            yeah, it works
            marginTop: "0",
            marginLeft: "4px",
            marginRight: "4px"
        }
    }*/

    // yes, this works!!!
    popperArrow: {
        '&[x-placement*="bottom"] .MuiTooltip-arrow': {
            top: "0",
            left: "0",
            //            marginTop: "-0.71em",
            // marginTop: "0!important",            yeah, it works
            marginTop: "-10px",
            marginLeft: "15px",
            marginRight: "12px",
            width: "16px",
        }
    }




    
}))(Tooltip)

export default function Dash3ColTable(props) {

    const { info,
            dataset,
            header1, header2,
            txtName, showPlace,
            showBar2, showBar3,
            showMark1
          } = props
    
    //log.trace("body: dataset =", dataset)
    //log.trace("body: info =", info)
    
    const classes = useStyles()
    const [order, setOrder] = React.useState('asc')
    const [orderBy, setOrderBy] = React.useState('column2')
    const [selected, setSelected] = React.useState([])
    const [page, setPage] = React.useState(0)
    const [dense, setDense] = React.useState(true)
    const [chartBackgroundColor, setChartBackgroundColor] = React.useState("white")
    const [infoOpen, setInfoOpen] = React.useState(false)

    // eslint-disable-next-line
    const handleInfoOpen = () => {
        setInfoOpen(true)
    }

    // eslint-disable-next-line
    const handleInfoClosed = () => {
        setInfoOpen(false)
    }
        
    // const [currentColumn1, setCurrentColumn1] = React.useState(null)

    let rows = dataset

    /*
    if(dataset) {
        rows = dataset.map(d => {
            log.trace("map: setting up rows, d =",d)
            let column1
            let column1UUID
            if(d.column1 && d.column1.txt) {
                column1 = d.column1.val
                column1UUID = d.column1.uuid
            } else {
                column1 = "Loading..."
            }
            
            let column2
            if(d.column2 && d.column2.val) {
                column2 = d.column2.val
            } else {
                column2 = "Loading..."
            }

            return {
                column1: column1,
                column2: column2,
                item: {
                    uuid: column1UUID,
                    column1: {
                        uuid: "column1 uuid",
                        txt: "column1 txt"
                    },
                    statement: {
                        uuid: "statement uuid",
                        txt: "statement txt"
                    }
                },
            }
        })
            .reduce((rows, d) => { // make sure that we get 1 row per column1 only
                log.trace("reduce: rows =",rows)
                log.trace("reduce: d =",d)
                if(!rows.find(row => row.column1 === d.column1))
                    rows.push(d)
                return rows
            },[])
    }
    */

    log.trace("body: rows =",rows)

    // config, this 5 is config
    const [rowsPerPage, setRowsPerPage] = React.useState(50)

    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };

    const handleSelectAllClick = event => {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.column1.val);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, row) => {
        log.trace("handleClick(): event =", event)
        if(props.onRowClick) props.onRowClick(row, event) // we might need to see if it's double click here
    }
    
    // eslint-disable-next-line
    const handleClick_old = (event, column1) => {
        const selectedIndex = selected.indexOf(column1);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, column1);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    }

    // eslint-disable-next-line
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    };

    // eslint-disable-next-line
    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    // eslint-disable-next-line
    const handleChangeDense = event => {
        setDense(event.target.checked);
    }

    const handleMouseOver = row => event => {
        setInfoOpen("false")
        log.trace("handleMouseOver(): infoOpen =",infoOpen)

        //event.stopPropagation()
        //event.preventDefault()
        
        //if(infoOpen) {
        //            return
        //        }
        
        log.trace("handleMouseOver(): row =",row)
        log.trace("handleMouseOver(): props =", props)
        log.trace("handleMouseOver(): row.column1 =", row.column1)
        const chartID = `chartDiv-${row.column1.uuid}`
        log.trace("handleMouseOver(): chartID =", chartID)
        setChartBackgroundColor({
            [chartID]: "#f2f2f2"
        })
        // setCurrentColumn1(row.column1)
        props.onRowHover(row) // call upper-level routine 
    }


    const handleMouseOut = row => event => {
        // TODO: only do mouseout if we "really" left the column1
        // and are not staying on the same row
        //log.trace("handleMouseOut(): row =",row)
        //log.trace("handleMouseOut(): props =", props)
        //log.trace("handleMouseOut(): currentColumn1 =", currentColumn1)
        //log.trace("handleMouseOut(): row.column1 =", row.column1)
        setChartBackgroundColor("white") // we need it when we're out and not on any other charts
        props.onRowUnhover(row) // call upper-level routine 
    }


    const isSelected = column1 => selected.indexOf(column1) !== -1;

    // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    // const emptyRows = 0

//    const keyedRows = rows.map(r => {
//        return {
//            ...r,
//            key: `${r.column1.val}-${r.column1.uuid}` // this is quick and uuid might be indefined
//        }
//    })

    
    return (
        <div id="externalTooltipRoot-Dash3ColTable" className={classes.root}>
          <div id="externalTooltip-Dash3ColTable" className={classes.externalTooltip}>
            {/* <div id="name">name</div> */}
            {/* <div id="col1">count</div> */}
            {/* TODO: this can be brought back later when we have the data fitured out*/}
            {/* <div id="states">states</div>*/}
            {/* <div id="uscds">uscds</div> */}
            <div id="tooltipRow1" style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <Typography className={classes.tooltipItemName} variant="h6" id="tooltipItemName2">
                Positive:
              </Typography>
              <Typography className={classes.tooltipItemVal} variant="h6" id="tooltipItemVal2">
                <div className={classes.tooltipItemVal} id="pro">pro</div>
              </Typography>
            </div>

            <div id="tooltipRow2" style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <Typography className={classes.tooltipItemName} variant="h6" id="tooltipItemName3">
                Negative:
              </Typography>
              <Typography className={classes.tooltipItemVal} variant="h6" id="tooltipItemVal3">
                <div className={classes.tooltipItemVal} id="con">con</div>
              </Typography>
            </div>

            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <Typography className={classes.tooltipItemName} variant="h6" id="tooltipItemName1">
                Feedback Count:
              </Typography>
              <Typography className={classes.tooltipItemVal} variant="h6" id="tooltipItemVal1">
                <div className={classes.tooltipItemVal} id="count">count</div>
              </Typography>
            </div>
            <div className={classes.externalTooltipAnchor}></div>
          </div>
          
          <Paper className={classes.paper}>
            <EnhancedTableToolbar
        //              isInfoOpen={infoOpen}
        //              onInfoOpen={handleInfoOpen}
        //              onInfoClosed={handleInfoClosed}
              info={info}
              header1={header1}
              header2={header2}
              numSelected={selected.length} />
            {/*           <div className={classes.tableWrapper}>*/}
            <TableContainer className={classes.tableContainer}>
              <Table
                     stickyHeader
                     className={classes.table}
                     aria-labelledby="tableTitle"
                     size={dense ? 'small' : 'medium'}
                     aria-label="enhanced table"
              >
                <EnhancedTableHead
                  showPlace={showPlace}
                  txtName={txtName}
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                />
                <TableBody classes={{}}>
                  {stableSort(rows, getSorting(order, orderBy))
                   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                   .map((row, index) => {
                       const isItemSelected = isSelected(row.column1.val);
                       const labelId = `enhanced-table-checkbox-${index}`
                       // trace does not a cost
                       // log.trace("return(): TableBody: index =", index)
                       // log.trace("return(): TableBody: row =", row)
                       // log.trace("return(): TableBody: row.column1 =", row.column1)
                       // log.trace("return(): TableBody: dataset =", dataset)

                       const subset = dataset.filter(r => {
                           log.trace("body: map: r =", r)
                           //                           return  r.column1 && r.column1.val === row.column1.val
                           return  r.column1 && r.column1.uuid === row.column1.uuid
                       })

                       return (
                           <TableRow
                             hover={true}
                             onClick={event => handleClick(event, row)}
                             role="checkbox"
                             aria-checked={isItemSelected}
                             tabIndex={-1}
                             key={row.column1.uuid}
                             selected={isItemSelected}
                             onMouseOver={handleMouseOver(row)}
                             onMouseOut={handleMouseOut(row)}
                             classes={{
                                 root: classes.tableRowRoot
                             }}
                             style={{
                                 height: "64px"
                             }}
                           >
                             {showPlace &&
                              <TableCell padding="none"
                                         style={{
                                             textAlign: "center",
                                             fontSize: 17
                                         }}>
                                {index + 1}
                              </TableCell>
                             }
                             {/* column1 */}
                             <TableCell component="th" id={labelId} scope="row"
                                        className={classes.column1Value}>
                               {row.column1.val}
                             </TableCell>

                             {/* column2 */}
                             <TableCell align="right"
                                        padding="none"
                                        className={classes.column2Value}>
                               {row.column2.val}
                             </TableCell>


                             {/* column3 */}
                             <TableCell align="right"
                                        padding="none"
                                        className={classes.column3Value}>
                               {row.column3.val}
                             </TableCell>


                             {/* chart1 */}
                             <TableCell className={classes.chartCell}>
                               <div style={{
                                   height: 42,
                                   width: 200,
                                   backgroundColor: "yellow"
                               }}>
                                 <DashBarChart
                                   externalTooltip={true}
                                   externalTooltipID = "externalTooltip-Dash3ColTable"
                                   externalTooltipRootID = "externalTooltipRoot-Dash3ColTable"
                                   chartID = {`chartDiv-${subset[0].column1.uuid}`}
                                   superset={dataset}
                                   dataset={subset}
                                   showXAxis={false}
                                   showYAxis={false}
                                   showBar1={true}
                                   showBar2={showBar2}
                                   showBar3={showBar3}
                                   showMark1={showMark1}
                                   onChartHover={props.onChartHover}
                                   onChartUnhover={props.onChartUnhover}
                                   chartBackgroundColor={chartBackgroundColor}
                                 />

                               </div>
                             </TableCell>


                             
                             {/*
                                <TableCell align="left">
                                <div style={{
                                display: "flex",
                                alignItems: "flex-end"
                                }}>
                                <div id="bar-chart-wrapper" style={{
                                backgroundColor: "yellow",
                                height: 50,
                                width: 100,
                                }}>HAHAH
                                <DashBarChart
                                dataset={[dataset[0]]}
                                superset={dataset}
                                showXAxis={false}
                                showYAxis={false}
                                />
                                </div>
                                </div>
                                </TableCell>
                              */}

                           </TableRow>
                       );
                   })}
                  {/*
                  {emptyRows > 0 && (
                      <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                  )}
                   */}

                  <TableRow style={{ height: "100%" }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                  
                </TableBody>
              </Table>
              </TableContainer>
            {/*            </div> */}
            {/*
               <TablePagination
               rowsPerPageOptions={[5, 10, 25]}
               component="div"
               count={rows.length}
               rowsPerPage={rowsPerPage}
               page={page}
               onChangePage={handleChangePage}
               onChangeRowsPerPage={handleChangeRowsPerPage}
               />
             */}
          </Paper>

        {/*
          <FormControlLabel
            control={<Switch checked={dense} onChange={handleChangeDense} />}
            label="Dense padding"
          />
         */}
        </div>
    );
}
